"use strict";

var PRODUCTS = require('../../constants');

function parsePackageType(string) {
  var identifiers = [{
    title: 'Letterpress Wedding Invitations - Sample',
    constructor: PRODUCTS.LETTERPRESS_WEDDING_INVITATION_SAMPLES
  }, {
    title: 'Wedding Invitations - Sample',
    constructor: PRODUCTS.CLASSIC_WEDDING_INVITATION_SAMPLES
  }, {
    title: 'Wedding Invitation - Sample',
    constructor: PRODUCTS.CLASSIC_WEDDING_INVITATION_SAMPLES
  }, {
    title: 'Letterpress Wedding Invitation',
    constructor: PRODUCTS.LETTERPRESS_WEDDING_INVITATIONS
  }, {
    title: 'Ribbon Wedding Invitation',
    constructor: PRODUCTS.RIBBON_WEDDING_INVITATIONS
  }, {
    title: 'Floral Wedding Invitation',
    constructor: PRODUCTS.FLORAL_WEDDING_INVITATIONS
  }, {
    title: 'Vellum Wedding Invitation',
    constructor: PRODUCTS.VELLUM_WEDDING_INVITATIONS
  }, {
    title: 'Color Chart',
    constructor: PRODUCTS.COLOR_CHARTS
  }, {
    title: 'Wedding Invitation',
    constructor: PRODUCTS.CLASSIC_WEDDING_INVITATIONS
  }, {
    title: 'Thank You Card',
    constructor: PRODUCTS.THANK_YOU_CARDS
  }, {
    title: 'Table Number',
    constructor: PRODUCTS.TABLE_NUMBERS
  }, {
    title: 'Wedding Sign',
    constructor: PRODUCTS.WEDDING_SIGNS
  }, {
    title: 'Custom Sign',
    constructor: PRODUCTS.CUSTOM_SIGNS
  }, {
    title: 'Sign',
    constructor: PRODUCTS.RESERVED_SIGNS
  }, // {
  //     title: 'Custom Stamp',
  //     constructor: PRODUCTS.CUSTOM_STAMPS,
  // },
  {
    title: 'Booklet Wedding Program',
    constructor: PRODUCTS.BASIC_BOOKLET_WEDDING_PROGRAMS
  }, {
    title: 'Wedding Program',
    constructor: PRODUCTS.SQUARE_WEDDING_PROGRAMS
  }, {
    title: 'Wedding Menu',
    constructor: PRODUCTS.WEDDING_MENUS
  }, {
    title: 'Dinner Menu',
    constructor: PRODUCTS.WEDDING_MENUS
  }, {
    title: 'Save the Date',
    constructor: PRODUCTS.SAVE_THE_DATES
  }, {
    title: 'Place Card',
    constructor: PRODUCTS.PLACE_CARDS
  }, {
    title: 'Silk Ribbon Samples',
    constructor: PRODUCTS.SILK_RIBBON_SAMPLES
  }, {
    title: 'Silk Ribbon',
    constructor: PRODUCTS.SILK_RIBBON
  }, {
    title: 'Vellum Jacket',
    constructor: PRODUCTS.VELLUM_JACKETS
  }, {
    title: 'Wax Seal',
    constructor: PRODUCTS.WAX_SEALS
  }];
  var packageType;

  for (var i = 0; i < identifiers.length; i++) {
    if (string.match(new RegExp(identifiers[i].title, 'i'))) {
      packageType = identifiers[i].constructor;
      break;
    }
  }

  return packageType;
}

module.exports = parsePackageType;